import _ from 'lodash';
import iban from 'iban';
import moment from 'moment-timezone';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _classPrivateFieldGet2(s, a) {
  return s.get(_assertClassBrand(s, a));
}
function _classPrivateFieldInitSpec(e, t, a) {
  _checkPrivateRedeclaration(e, t), t.set(e, a);
}
function _classPrivateFieldSet2(s, a, r) {
  return s.set(_assertClassBrand(s, a), r), r;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _HttpResponseParser;
var HttpResponseParser = /*#__PURE__*/_createClass(function HttpResponseParser() {
  _classCallCheck(this, HttpResponseParser);
});
_HttpResponseParser = HttpResponseParser;
var _parseObjectError = {
  _: function _$1(message, objectErrors) {
    var fields = _.transform(objectErrors, function (errors, fieldError, fieldName) {
      errors[fieldName] = _HttpResponseParser.parse(fieldError);
    }, {});
    return _objectSpread2({
      message: message
    }, fields);
  }
};
var _parseArrayError = {
  _: function _$1(message, arrayErrors) {
    var items = _.transform(arrayErrors, function (errors, itemError, itemIndex) {
      errors["Index(".concat(itemIndex, ")")] = _HttpResponseParser.parse(itemError);
    }, {});
    return _objectSpread2({
      message: message
    }, items);
  }
};
/**
 * @param {object[]} validationResult
 * @returns {{ message: string, fields: object?, items: object? }}
 */
_defineProperty(HttpResponseParser, "parse", function (validationResult) {
  return _.map(validationResult, function (_ref) {
    var message = _ref.message,
      schemaErrors = _ref.schemaErrors,
      valueErrors = _ref.valueErrors,
      itemErrors = _ref.itemErrors;
    if (message && schemaErrors && !valueErrors && !itemErrors) {
      return _parseObjectError._.call(_HttpResponseParser, message, schemaErrors);
    }
    if (message && !schemaErrors && valueErrors && !itemErrors) {
      return _parseObjectError._.call(_HttpResponseParser, message, valueErrors);
    }
    if (message && !schemaErrors && !valueErrors && itemErrors) {
      return _parseArrayError._.call(_HttpResponseParser, message, itemErrors);
    }
    return message;
  });
});

var _validations = /*#__PURE__*/new WeakMap();
var _errors = /*#__PURE__*/new WeakMap();
var _childInstance = /*#__PURE__*/new WeakMap();
var _clearErrors = /*#__PURE__*/new WeakMap();
var GenericValidation = /*#__PURE__*/_createClass(function GenericValidation() {
  var _this = this;
  _classCallCheck(this, GenericValidation);
  _classPrivateFieldInitSpec(this, _validations, []);
  _classPrivateFieldInitSpec(this, _errors, []);
  _classPrivateFieldInitSpec(this, _childInstance, null);
  _classPrivateFieldInitSpec(this, _clearErrors, function () {
    _classPrivateFieldSet2(_errors, _this, []);
  });
  _defineProperty(this, "removeDefaultTypeValidation", function () {
    var _classPrivateFieldGet2$1;
    _classPrivateFieldSet2(_validations, _this, !_classPrivateFieldGet2(_childInstance, _this) || _.size(_classPrivateFieldGet2(_validations, _this)) === 1 ? _classPrivateFieldGet2(_validations, _this) : _.slice(_classPrivateFieldGet2(_validations, _this), 1));
    return (_classPrivateFieldGet2$1 = _classPrivateFieldGet2(_childInstance, _this)) !== null && _classPrivateFieldGet2$1 !== void 0 ? _classPrivateFieldGet2$1 : _this;
  });
  /**
   * @param {function(any): boolean} expression
   * @param {function(boolean): string} errorMessageGetter
   * @return {this}
   * @example generic().is((parameter) => parameter === 1).validate(1)
   */
  _defineProperty(this, "is", function (expression) {
    var _classPrivateFieldGet3;
    var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return 'value is not valid';
    };
    _classPrivateFieldGet2(_validations, _this).push(function (value, isNegatedValidation) {
      var isValid = expression(value, isNegatedValidation);
      if (isNegatedValidation ? isValid : !isValid) {
        var errorMessage = errorMessageGetter(isNegatedValidation);
        var structuredError = _.isString(errorMessage) ? {
          message: errorMessage
        } : errorMessage;
        _classPrivateFieldGet2(_errors, _this).push(structuredError);
      }
    });
    return (_classPrivateFieldGet3 = _classPrivateFieldGet2(_childInstance, _this)) !== null && _classPrivateFieldGet3 !== void 0 ? _classPrivateFieldGet3 : _this;
  });
  /**
   * @param {GenericValidation} validation
   * @return {this}
   * @example generic().not(string.isInteger()).validate("abc")
   */
  _defineProperty(this, "not", function (validation) {
    var _classPrivateFieldGet5;
    _classPrivateFieldGet2(_validations, _this).push(function (value, isNegatedValidation) {
      var validationErrors = validation.removeDefaultTypeValidation().validate(value, !isNegatedValidation);
      if (!_.isEmpty(validationErrors)) {
        var _classPrivateFieldGet4;
        (_classPrivateFieldGet4 = _classPrivateFieldGet2(_errors, _this)).push.apply(_classPrivateFieldGet4, _toConsumableArray(validationErrors));
      }
    });
    return (_classPrivateFieldGet5 = _classPrivateFieldGet2(_childInstance, _this)) !== null && _classPrivateFieldGet5 !== void 0 ? _classPrivateFieldGet5 : _this;
  });
  /**
   * @param {GenericValidation[]} orValidations
   * @return {this}
   * @example generic().or(string.isInteger(), string.isDecimal()).validate("1.22")
   */
  _defineProperty(this, "or", function () {
    var _classPrivateFieldGet7;
    for (var _len = arguments.length, orValidations = new Array(_len), _key = 0; _key < _len; _key++) {
      orValidations[_key] = arguments[_key];
    }
    _classPrivateFieldGet2(_validations, _this).push(function (value, isNegatedValidation) {
      var orValidationErrors = _.transform(orValidations, function (result, orValidation) {
        var validationErrors = orValidation.validate(value, isNegatedValidation);
        if (!_.isEmpty(validationErrors)) {
          result.push(validationErrors);
        }
      }, []);
      if (isNegatedValidation ? _.size(orValidationErrors) > 0 : _.size(orValidationErrors) === _.size(orValidations)) {
        var _classPrivateFieldGet6;
        (_classPrivateFieldGet6 = _classPrivateFieldGet2(_errors, _this)).push.apply(_classPrivateFieldGet6, _toConsumableArray(_.flatten(orValidationErrors)));
      }
    });
    return (_classPrivateFieldGet7 = _classPrivateFieldGet2(_childInstance, _this)) !== null && _classPrivateFieldGet7 !== void 0 ? _classPrivateFieldGet7 : _this;
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isArray().validate([])
   */
  _defineProperty(this, "isArray", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be an array");
    };
    return _this.is(function (value) {
      return _.isArray(value);
    }, errorMessageGetter);
  });
  /**
   * @example generic().isAny().validate([])
   */
  _defineProperty(this, "isAny", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be of type any");
    };
    return _this.is(function (value) {
      return true;
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isObject().validate({})
   */
  _defineProperty(this, "isObject", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be an object");
    };
    return _this.is(function (value) {
      return _.isPlainObject(value);
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isNumber().validate(2)
   */
  _defineProperty(this, "isNumber", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a number");
    };
    return _this.is(function (value) {
      return _.isNumber(value);
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isString().validate("2")
   */
  _defineProperty(this, "isString", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a string");
    };
    return _this.is(function (value) {
      return _.isString(value);
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isBigInt().validate(222222222222222222222222222)
   */
  _defineProperty(this, "isBigInt", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a big int");
    };
    return _this.is(function (value) {
      return typeof value === 'bigint';
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isBoolean().validate(true)
   */
  _defineProperty(this, "isBoolean", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a boolean");
    };
    return _this.is(function (value) {
      return _.isBoolean(value);
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isFunction().validate(() => {})
   */
  _defineProperty(this, "isFunction", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a function");
    };
    return _this.is(function (value) {
      return _.isFunction(value);
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isSymbol().validate(new Symbol())
   */
  _defineProperty(this, "isSymbol", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a symbol");
    };
    return _this.is(function (value) {
      return _.isSymbol(value);
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isNull().validate(null)
   */
  _defineProperty(this, "isNull", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be null");
    };
    return _this.is(function (value) {
      return _.isNull(value);
    }, errorMessageGetter);
  });
  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isUndefined().validate(undefined)
   */
  _defineProperty(this, "isUndefined", function () {
    var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be undefined");
    };
    return _this.is(function (value) {
      return _.isUndefined(value);
    }, errorMessageGetter);
  });
  /**
   * @template T
   * @param {T} type
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isInstanceOf(Object).validate({})
   */
  _defineProperty(this, "isInstanceOf", function (type) {
    var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be an instance of type ").concat(type.name);
    };
    return _this.is(function (value) {
      return value instanceof type;
    }, errorMessageGetter);
  });
  /**
   * @param {any} valueTarget
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isEqual(6).validate(6)
   */
  _defineProperty(this, "isEqual", function (valueTarget) {
    var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be equal to ").concat(valueTarget);
    };
    return _this.is(function (value) {
      return _.isEqual(value, valueTarget);
    }, errorMessageGetter);
  });
  /**
   * @param {any} valueTarget
   * @param {function(boolean): string} errorMessageGetter
   * @example generic().isNotEqual(6).validate(4)
   */
  _defineProperty(this, "isNotEqual", function (valueTarget) {
    var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be different from ").concat(valueTarget);
    };
    return _this.is(function (value) {
      return !_.isEqual(value, valueTarget);
    }, errorMessageGetter);
  });
  /**
   * @param {any} value
   * @param {boolean} isNegatedValidation
   */
  _defineProperty(this, "validate", function (value) {
    var isNegatedValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _.each(_classPrivateFieldGet2(_validations, _this), function (validation) {
      return validation(value, isNegatedValidation);
    });
    var errors = _.uniqWith(_classPrivateFieldGet2(_errors, _this), _.isEqual);
    _classPrivateFieldGet2(_clearErrors, _this).call(_this);
    return errors;
  });
  _defineProperty(this, "toJSON", function () {
    return _this.constructor.name;
  });
  return _objectSpread2(_objectSpread2({}, this), {}, {
    setChildInstance: function setChildInstance(instance) {
      _classPrivateFieldSet2(_childInstance, _this, instance);
    }
  });
});

var BooleanValidation = /*#__PURE__*/function (_GenericValidation) {
  /** @param {function(boolean): string} errorMessageGetter */
  function BooleanValidation() {
    var _this;
    var _errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a boolean");
    };
    _classCallCheck(this, BooleanValidation);
    var _ref = (_this = _callSuper(this, BooleanValidation), _defineProperty(_assertThisInitialized(_this), "isTrue", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "boolean should".concat(isNegatedValidation ? ' not' : '', " be ", true);
        };
        return _this.is(function (value) {
          return value === true;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isFalse", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "boolean should".concat(isNegatedValidation ? ' not' : '', " be ", false);
        };
        return _this.is(function (value) {
          return value === false;
        }, errorMessageGetter);
      })),
      setChildInstance = _ref.setChildInstance;
    setChildInstance(_this);
    _this.isBoolean(_errorMessageGetter);
    return _this;
  }

  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example boolean().isTrue().validate(5===5)
   */
  _inherits(BooleanValidation, _GenericValidation);
  return _createClass(BooleanValidation);
}(GenericValidation);

var NumberValidation = /*#__PURE__*/function (_GenericValidation) {
  /** @param {function(boolean): string} errorMessageGetter */
  function NumberValidation() {
    var _this;
    var _errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a number");
    };
    _classCallCheck(this, NumberValidation);
    var _ref = (_this = _callSuper(this, NumberValidation), _defineProperty(_assertThisInitialized(_this), "isNaN", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be ").concat(NaN);
        };
        return _this.is(function (value) {
          return _.isNaN(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isInfinity", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be ").concat(Infinity);
        };
        return _this.is(function (value) {
          return value === -Infinity || value === Infinity;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isFinite", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be finite");
        };
        return _this.is(function (value) {
          return _.isFinite(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isInteger", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be an integer");
        };
        return _this.is(function (value) {
          return _.isInteger(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isDecimal", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be a decimal number");
        };
        return _this.is(function (value) {
          return _.isFinite(value) && Math.floor(value) !== value;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isPositive", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be positive");
        };
        return _this.is(function (value) {
          return _.isNumber(value) && value > 0;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isNegative", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be negative");
        };
        return _this.is(function (value) {
          return _.isNumber(value) && value < 0;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isBiggerThan", function (targetValue) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be larger than ").concat(targetValue);
        };
        return _this.is(function (value) {
          return _.isNumber(value) && value > targetValue;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isBiggerThanEqual", function (targetValue) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be larger or equal to ").concat(targetValue);
        };
        return _this.is(function (value) {
          return _.isNumber(value) && value >= targetValue;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isSmallerThan", function (targetValue) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be smaller than ").concat(targetValue);
        };
        return _this.is(function (value) {
          return _.isNumber(value) && value < targetValue;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isSmallerThanEqual", function (targetValue) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be smaller or equal to ").concat(targetValue);
        };
        return _this.is(function (value) {
          return _.isNumber(value) && value <= targetValue;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isInRange", function (minValue, maxValue) {
        var errorMessageGetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (isNegatedValidation) {
          return "number should".concat(isNegatedValidation ? ' not' : '', " be between ").concat(minValue, " and ").concat(maxValue);
        };
        return _this.is(function (value) {
          return _.isNumber(value) && value >= minValue && value <= maxValue;
        }, errorMessageGetter);
      })),
      setChildInstance = _ref.setChildInstance;
    setChildInstance(_this);
    _this.isNumber(_errorMessageGetter);
    return _this;
  }

  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example number().isNaN().validate('abc')
   */
  _inherits(NumberValidation, _GenericValidation);
  return _createClass(NumberValidation);
}(GenericValidation);

var ArrayValidation = /*#__PURE__*/function (_GenericValidation) {
  /** @param {function(boolean): string} errorMessageGetter */
  function ArrayValidation() {
    var _this;
    var _errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be an array");
    };
    _classCallCheck(this, ArrayValidation);
    var _ref = (_this = _callSuper(this, ArrayValidation), _defineProperty(_assertThisInitialized(_this), "isEmpty", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "array should".concat(isNegatedValidation ? ' not' : '', " be empty");
        };
        return _this.is(function (value) {
          return _.isEmpty(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isNotEmpty", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "array should".concat(isNegatedValidation ? '' : ' not', " be empty");
        };
        return _this.is(function (value) {
          return !_.isEmpty(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "arrays length should".concat(isNegatedValidation ? ' not' : '', " be exactly '").concat(length, "'");
        };
        return _this.is(function (value) {
          return _.size(value) === length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isMaxLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "arrays length should".concat(isNegatedValidation ? ' not' : '', " be maximum '").concat(length, "'");
        };
        return _this.is(function (value) {
          return _.size(value) <= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isMinLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "arrays length should".concat(isNegatedValidation ? ' not' : '', " be minimum '").concat(length, "'");
        };
        return _this.is(function (value) {
          return _.size(value) >= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLengthInRangeOf", function (minLength, maxLength) {
        var errorMessageGetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (isNegatedValidation) {
          return "arrays length should".concat(isNegatedValidation ? ' not' : '', " be between '").concat(minLength, "' and '").concat(maxLength, "'");
        };
        return _this.is(function (value) {
          return _.size(value) >= minLength && _.size(value) <= maxLength;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "includes", function (valueToExist) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "'".concat(valueToExist, "' should").concat(isNegatedValidation ? ' not' : '', " be included in the array");
        };
        return _this.is(function (value) {
          return !!_.find(value, function (item) {
            return _.isEqual(item, valueToExist);
          });
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isEveryItem", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'every item in the array needs to match the provided validation';
        };
        var itemErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "itemErrors" may contain previous validation errors, so it needs to be cleaned (maybe there is better solution ?)
          itemErrors = {};
          var validationErrors = _.flatMap(value, function (item, index) {
            var itemValidationErrorsMessages = validation.validate(item, isNegatedValidation);
            if (!_.isEmpty(itemValidationErrorsMessages)) {
              itemErrors[index] = itemValidationErrorsMessages;
            }
            return itemValidationErrorsMessages;
          });
          return isNegatedValidation ? !_.isEmpty(validationErrors) : _.isEmpty(validationErrors);
        }, function () {
          return {
            message: errorMessageGetter(),
            itemErrors: itemErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isNoneOfItems", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'every item in the array needs to match the provided validation';
        };
        var itemErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "itemErrors" may contain previous validation errors, so it needs to be cleaned (maybe there is better solution ?)
          itemErrors = {};
          var validationErrors = _.flatMap(value, function (item, index) {
            var itemValidationErrorsMessages = validation.validate(item, !isNegatedValidation);
            if (!_.isEmpty(itemValidationErrorsMessages)) {
              itemErrors[index] = itemValidationErrorsMessages;
            }
            return itemValidationErrorsMessages;
          });
          return isNegatedValidation ? !_.isEmpty(validationErrors) : _.isEmpty(validationErrors);
        }, function () {
          return {
            message: errorMessageGetter(),
            itemErrors: itemErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isOneOfItems", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'at least one item in the array needs to pass the provided validation';
        };
        var itemErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "itemErrors" may contain previous validation errors, so it needs to be cleaned (maybe there is better solution ?)
          itemErrors = {};
          var validationErrors = _.flatMap(value, function (item, index) {
            var itemValidationErrorsMessages = validation.validate(item, isNegatedValidation);
            if (!_.isEmpty(itemValidationErrorsMessages)) {
              itemErrors[index] = itemValidationErrorsMessages;
            }
            return itemValidationErrorsMessages;
          });
          return isNegatedValidation ? _.size(validationErrors) >= _.size(value) : _.size(validationErrors) < _.size(value);
        }, function () {
          return {
            message: errorMessageGetter(),
            itemErrors: itemErrors
          };
        });
      })),
      setChildInstance = _ref.setChildInstance;
    setChildInstance(_this);
    _this.isArray(_errorMessageGetter);
    return _this;
  }

  /**
   *  @param {function(boolean): string} errorMessageGetter
   *  @example array().isEmpty().validate([])
   */
  _inherits(ArrayValidation, _GenericValidation);
  return _createClass(ArrayValidation);
}(GenericValidation);

var FunctionValidation = /*#__PURE__*/function (_GenericValidation) {
  /** @param {function(boolean): string} errorMessageGetter */
  function FunctionValidation() {
    var _this;
    var _errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a function");
    };
    _classCallCheck(this, FunctionValidation);
    var _ref = (_this = _callSuper(this, FunctionValidation), _defineProperty(_assertThisInitialized(_this), "areParametersLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "functions parameters length should".concat(isNegatedValidation ? ' not' : '', " be exactly '").concat(length, "'");
        };
        return _this.is(function (value) {
          return value.length === length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "areParametersMaxLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "functions parameters length should".concat(isNegatedValidation ? ' not' : '', " be maximum '").concat(length, "'");
        };
        return _this.is(function (value) {
          return value.length <= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "areParametersMinLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "functions parameters length should".concat(isNegatedValidation ? ' not' : '', " be minimum '").concat(length, "'");
        };
        return _this.is(function (value) {
          return value.length >= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "areParametersLengthInRangeOf", function (minLength, maxLength) {
        var errorMessageGetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (isNegatedValidation) {
          return "functions parameters length should".concat(isNegatedValidation ? ' not' : '', " be between '").concat(minLength, "' and '").concat(maxLength, "'");
        };
        return _this.is(function (value) {
          return value.length >= minLength && value.length <= maxLength;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isNamed", function () {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "function should".concat(isNegatedValidation ? ' not' : '', " be named '").concat(name, "'");
        };
        return _this.is(function (value) {
          return value.name === name;
        }, errorMessageGetter);
      })),
      setChildInstance = _ref.setChildInstance;
    setChildInstance(_this);
    _this.isFunction(_errorMessageGetter);
    return _this;
  }

  /**
   * @param {number} length
   * @param {function(boolean): string} errorMessageGetter
   * @example functions().areParametersLengthOf(2).validate((a,b)=>{})
   */
  _inherits(FunctionValidation, _GenericValidation);
  return _createClass(FunctionValidation);
}(GenericValidation);

var ObjectValidation = /*#__PURE__*/function (_GenericValidation) {
  /** @param {function(boolean): string} errorMessageGetter */
  function ObjectValidation() {
    var _this;
    var _errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be an object");
    };
    _classCallCheck(this, ObjectValidation);
    var _ref = (_this = _callSuper(this, ObjectValidation), _defineProperty(_assertThisInitialized(_this), "areKeysLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "object should".concat(isNegatedValidation ? ' not' : '', " contain exactly '").concat(length, "' keys");
        };
        return _this.is(function (value) {
          return _.size(_.keys(value)) === length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "areKeysMaxLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "object should ".concat(isNegatedValidation ? ' not' : '', " contain maximum '").concat(length, "' keys");
        };
        return _this.is(function (value) {
          return _.size(_.keys(value)) <= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "areKeysMinLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "object should ".concat(isNegatedValidation ? ' not' : '', " contain minimum '").concat(length, "' keys");
        };
        return _this.is(function (value) {
          return _.size(_.keys(value)) >= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "areKeysLengthInRangeOf", function (minLength, maxLength) {
        var errorMessageGetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (isNegatedValidation) {
          return "object should ".concat(isNegatedValidation ? ' not' : '', " contain between '").concat(minLength, "' and '").concat(maxLength, "' keys");
        };
        return _this.is(function (value) {
          return _.size(_.keys(value)) >= minLength && _.size(_.keys(value)) <= maxLength;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "hasKeys", function (keys) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "object should".concat(isNegatedValidation ? ' not' : '', " contain keys '").concat(keys, "'");
        };
        return _this.is(function (value) {
          var existingKeys = _.keys(value);
          return _.every(keys, function (keyToBeIncluded) {
            return _.includes(existingKeys, keyToBeIncluded);
          });
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "hasValues", function (values) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "object should".concat(isNegatedValidation ? ' not' : '', " contain values '").concat(values, "'");
        };
        return _this.is(function (value) {
          var existingValues = _.values(value);
          return _.every(values, function (valueToBeIncluded) {
            return _.some(existingValues, function (existingValue) {
              return _.isEqual(valueToBeIncluded, existingValue);
            });
          });
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "includes", function (object) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "object should".concat(isNegatedValidation ? ' not' : '', " include: '").concat(JSON.stringify(object), "'");
        };
        return _this.is(function (value) {
          return _.isMatch(value, object);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isEmpty", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "object should".concat(isNegatedValidation ? ' not' : '', " be empty");
        };
        return _this.is(function (value) {
          return _.isEmpty(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isEveryKey", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'every key in the object needs to match validation:';
        };
        var valueErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "valueErrors" may contain previous validation errors when called for each item in an array, so it needs to be cleaned (maybe there is better solution ?)
          valueErrors = {};
          var validationErrors = _.flatMap(_.keys(value), function (key) {
            var valueValidationErrorsMessages = validation.validate(key, isNegatedValidation);
            if (!_.isEmpty(valueValidationErrorsMessages)) {
              valueErrors[key] = valueValidationErrorsMessages;
            }
            return valueValidationErrorsMessages;
          });
          return isNegatedValidation ? !_.isEmpty(validationErrors) : _.isEmpty(validationErrors);
        }, function () {
          return {
            message: errorMessageGetter(),
            valueErrors: valueErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isNoneOfKeys", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'every key in the object needs to match validation:';
        };
        var valueErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "valueErrors" may contain previous validation errors when called for each item in an array, so it needs to be cleaned (maybe there is better solution ?)
          valueErrors = {};
          var validationErrors = _.flatMap(_.keys(value), function (key) {
            var valueValidationErrorsMessages = validation.validate(key, !isNegatedValidation);
            if (!_.isEmpty(valueValidationErrorsMessages)) {
              valueErrors[key] = valueValidationErrorsMessages;
            }
            return valueValidationErrorsMessages;
          });
          return isNegatedValidation ? !_.isEmpty(validationErrors) : _.isEmpty(validationErrors);
        }, function () {
          return {
            message: errorMessageGetter(),
            valueErrors: valueErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isOneOfKeys", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'at least one key in the object needs to match validation: ';
        };
        var valueErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "valueErrors" may contain previous validation errors when called for each item in an array, so it needs to be cleaned (maybe there is better solution ?)
          valueErrors = {};
          var objectKeys = _.keys(value);
          var validationErrors = _.flatMap(_.keys(value), function (key) {
            var valueValidationErrorsMessages = validation.validate(key, isNegatedValidation);
            if (!_.isEmpty(valueValidationErrorsMessages)) {
              valueErrors[key] = valueValidationErrorsMessages;
            }
            return valueValidationErrorsMessages;
          });
          return isNegatedValidation ? _.size(validationErrors) >= _.size(objectKeys) : _.size(validationErrors) < _.size(objectKeys);
        }, function () {
          return {
            message: errorMessageGetter(),
            valueErrors: valueErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isEveryValue", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'every value in the object needs to match validation: ';
        };
        var valueErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "valueErrors" may contain previous validation errors when called for each item in an array, so it needs to be cleaned (maybe there is better solution ?)
          valueErrors = {};
          var objectValues = _.values(value);
          var objectKeys = _.keys(value);
          var validationErrors = _.flatMap(objectValues, function (item, index) {
            var valueValidationErrorsMessages = validation.validate(item, isNegatedValidation);
            if (!_.isEmpty(valueValidationErrorsMessages)) {
              valueErrors[objectKeys[index]] = valueValidationErrorsMessages;
            }
            return valueValidationErrorsMessages;
          });
          return isNegatedValidation ? !_.isEmpty(validationErrors) : _.isEmpty(validationErrors);
        }, function () {
          return {
            message: errorMessageGetter(),
            valueErrors: valueErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isNoneOfValues", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'every value in the object needs to match validation: ';
        };
        var valueErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "valueErrors" may contain previous validation errors when called for each item in an array, so it needs to be cleaned (maybe there is better solution ?)
          valueErrors = {};
          var objectValues = _.values(value);
          var objectKeys = _.keys(value);
          var validationErrors = _.flatMap(objectValues, function (item, index) {
            var valueValidationErrorsMessages = validation.validate(item, !isNegatedValidation);
            if (!_.isEmpty(valueValidationErrorsMessages)) {
              valueErrors[objectKeys[index]] = valueValidationErrorsMessages;
            }
            return valueValidationErrorsMessages;
          });
          return isNegatedValidation ? !_.isEmpty(validationErrors) : _.isEmpty(validationErrors);
        }, function () {
          return {
            message: errorMessageGetter(),
            valueErrors: valueErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isOneOfValues", function (validation) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
          return 'at least one value in the object needs to pass the provided validation';
        };
        var valueErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "valueErrors" may contain previous validation errors when called for each item in an array, so it needs to be cleaned (maybe there is better solution ?)
          valueErrors = {};
          var objectValues = _.values(value);
          var objectKeys = _.keys(value);
          var validationErrors = _.flatMap(objectValues, function (value, index) {
            var valueValidationErrorsMessages = validation.validate(value, isNegatedValidation);
            if (!_.isEmpty(valueValidationErrorsMessages)) {
              valueErrors[objectKeys[index]] = valueValidationErrorsMessages;
            }
            return valueValidationErrorsMessages;
          });
          return isNegatedValidation ? _.size(validationErrors) >= _.size(objectValues) : _.size(validationErrors) < _.size(objectValues);
        }, function () {
          return {
            message: errorMessageGetter(),
            valueErrors: valueErrors
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "isMatchingSchema", function (schema) {
        var isExactMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var errorMessageGetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
          return 'object needs to match the provided schema';
        };
        var schemaErrors;
        return _this.is(function (value, isNegatedValidation) {
          // "schemaErrors" may contain previous validation errors when called for each item in an array, so it needs to be cleaned (maybe there is better solution ?)
          schemaErrors = {};
          _.each(_.keys(value), function (propertyName) {
            if (isExactMatch && !_.has(schema, propertyName) && _.isPlainObject(value)) {
              schemaErrors[propertyName] = [{
                message: 'property is missing from the objects schema but is defined in the object'
              }];
            }
          });
          _.each(_.keys(schema), function (propertyName) {
            if (!_.has(value, propertyName)) {
              if (isExactMatch) {
                schemaErrors[propertyName] = [{
                  message: 'property is missing from the object but is defined in the objects schema'
                }];
              }
              return;
            }
            var propertyErrors = schema[propertyName].validate(value[propertyName], isNegatedValidation);
            if (!_.isEmpty(propertyErrors)) {
              schemaErrors[propertyName] = propertyErrors;
            }
          });
          return isNegatedValidation ? !_.isEmpty(schemaErrors) : _.isEmpty(schemaErrors);
        }, function () {
          return {
            message: errorMessageGetter(),
            schemaErrors: schemaErrors
          };
        });
      })),
      setChildInstance = _ref.setChildInstance;
    setChildInstance(_this);
    _this.isObject(_errorMessageGetter);
    return _this;
  }

  /**
   * @param {number} length
   * @param {function(boolean): string} errorMessageGetter
   * @example object().areKeysLengthOf(1).validate({ "key": "value" })
   */
  _inherits(ObjectValidation, _GenericValidation);
  return _createClass(ObjectValidation);
}(GenericValidation);

var currencyCodes = new Set(["USD", "CAD", "EUR", "AED", "AFN", "ALL", "AMD", "ARS", "AUD", "AZN", "BAM", "BDT", "BGN", "BHD", "BIF", "BND", "BOB", "BRL", "BWP", "BYN", "BZD", "CDF", "CHF", "CLP", "CNY", "COP", "CRC", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EEK", "EGP", "ERN", "ETB", "GBP", "GEL", "GHS", "GNF", "GTQ", "HKD", "HNL", "HRK", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KHR", "KMF", "KRW", "KWD", "KZT", "LBP", "LKR", "LTL", "LVL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MOP", "MUR", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SDG", "SEK", "SGD", "SOS", "SYP", "THB", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "UYU", "UZS", "VEF", "VND", "XAF", "XOF", "YER", "ZAR", "ZMK", "ZWL"]);

var StringValidation = /*#__PURE__*/function (_GenericValidation) {
  /** @param {function(boolean): string} errorMessageGetter */
  function StringValidation() {
    var _this;
    var _errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
      return "value should".concat(isNegatedValidation ? ' not' : '', " be a string");
    };
    _classCallCheck(this, StringValidation);
    var _ref = (_this = _callSuper(this, StringValidation), _defineProperty(_assertThisInitialized(_this), "isEmail", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be an email");
        };
        var emailRegularExpression = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return _this.is(function (value) {
          return emailRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isSha256", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a valid Sha256 string");
        };
        var emailRegularExpression = /^[a-f0-9]{64}$/gi;
        return _this.is(function (value) {
          return emailRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isPhone", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a phone number");
        };
        var phoneRegularExpression = /^\+(?:[0-9] ?){6,14}[0-9]$/;
        return _this.is(function (value) {
          return phoneRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isIp", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be an IP");
        };
        var ipRegularExpression = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
        return _this.is(function (value) {
          return ipRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isDate", function () {
        var dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a date in the format of '").concat(dateFormat, "'");
        };
        return _this.is(function (value) {
          return moment(value, dateFormat, true).isValid();
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isDateTime", function () {
        var dateTimeFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD HH:mm:ss';
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a date time in the format of '").concat(dateTimeFormat, "'");
        };
        return _this.is(function (value) {
          return moment(value, dateTimeFormat, true).isValid();
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isDateTimeWithTimeZone", function () {
        var dateTimeFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD HH:mm:ssZ';
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a date time with time zone in the format of '").concat(dateTimeFormat, "'");
        };
        return _this.is(function (value) {
          return moment(value, dateTimeFormat, true).isValid();
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isIban", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be an IBAN");
        };
        return _this.is(function (value) {
          return iban.isValid(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isSwift", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a BIC/SWIFT");
        };
        var swiftRegularExpression = /^[A-z]{4}[A-z]{2}\w{2}(\w{3})?$/;
        return _this.is(function (value) {
          return swiftRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isJson", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a json string");
        };
        return _this.is(function (value) {
          try {
            var parsedValue = JSON.parse(value);
            if (parsedValue && _typeof(parsedValue) === 'object') {
              return true;
            }
          } catch (_unused) {
            return false;
          }
          return false;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isUrl", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be an URL");
        };
        return _this.is(function (value) {
          try {
            var url = new URL(value);
            if (url && _typeof(url) === 'object') {
              return true;
            }
          } catch (_unused2) {
            return false;
          }
          return false;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isUuid", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be an UUID");
        };
        return _this.is(function (value) {
          switch (true) {
            case /^[0-9A-F]{8}-[0-9A-F]{4}-[1][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(value):
            case /^[0-9A-F]{8}-[0-9A-F]{4}-[2][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(value):
            case /^[0-9A-F]{8}-[0-9A-F]{4}-[3][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(value):
            case /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(value):
            case /^[0-9A-F]{8}-[0-9A-F]{4}-[5][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(value):
              return true;
            default:
              return false;
          }
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isStrongPassword", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "password should".concat(isNegatedValidation ? ' not' : '', " contain at least 8 characters, 1 upper case letter, 1 lower case letter, 1 integer and 1 character out of @#$!^()%*?&");
        };
        var strongPasswordRegularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!^()%*?&])[A-Za-z\d@#$!^()%*?&]{8,}$/;
        return _this.is(function (value) {
          return strongPasswordRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isInteger", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be an integer");
        };
        var integerRegularExpression = /^-?\d+$/;
        return _this.is(function (value) {
          return integerRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isDecimal", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a decimal number");
        };
        var decimalRegularExpression = /^-?(\d+|\d*\.\d+)$/;
        return _this.is(function (value) {
          return decimalRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isHexaDecimal", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a hexadecimal number");
        };
        var hexadecimalRegularExpression = /^-?(0x|0h)?[0-9A-F]+$/i;
        return _this.is(function (value) {
          return hexadecimalRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isOctal", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be an octal number");
        };
        var octalRegularExpression = /^-?(0|0o)?[0-7]+$/i;
        return _this.is(function (value) {
          return octalRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isCurrency", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be in currency format");
        };
        var currencyRegularExpression = /^-?(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/i;
        return _this.is(function (value) {
          return currencyRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isCurrencyCode", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a 3 capital-letter currency code");
        };
        return _this.is(function (value) {
          return currencyCodes.has(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLetters", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only letters");
        };
        var lettersRegularExpression = /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])+$/g;
        return _this.is(function (value) {
          return lettersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLettersAndSpaces", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only letters and spaces");
        };
        var lettersAndSpacesRegularExpression = /^(?:[\t-\r A-Za-z\xA0\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2000-\u200A\u2028\u2029\u202F\u205F\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3000\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFEFF\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])+$/g;
        return _this.is(function (value) {
          return lettersAndSpacesRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isSingleSpace", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only one space at a time");
        };
        var singleSpaceRegex = /^([^\s]+\s)*[^\s]+$/;
        return _this.is(function (value) {
          return singleSpaceRegex.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLatinLettersAndSpaces", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only latin letters and spaces");
        };
        var lettersRegularExpression = /^[\pA-Za-z\s]*$/;
        return _this.is(function (value) {
          return lettersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isEnglishLetters", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only english letters");
        };
        var englishLettersRegularExpression = /^[A-Za-z]+$/;
        return _this.is(function (value) {
          return englishLettersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isUpperCaseEnglishLetters", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only upper case english letters");
        };
        var upperCaseEnglishLettersRegularExpression = /^[A-Z]+$/;
        return _this.is(function (value) {
          return upperCaseEnglishLettersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLowerCaseEnglishLetters", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only lower case english letters");
        };
        var lowerCaseEnglishLettersRegularExpression = /^[a-z]+$/;
        return _this.is(function (value) {
          return lowerCaseEnglishLettersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLettersAndNumbers", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only letters and numbers");
        };
        var lettersAndNumbersRegularExpression = /^(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDF50-\uDF59\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDCD0-\uDCEB\uDCF0-\uDCF9\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])+$/g;
        return _this.is(function (value) {
          return lettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isCreditCard", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be valid credit card number");
        };
        var lettersAndNumbersRegularExpression = /^(?:4\d{3}|2\d{3}|6\d{3}|5[1-5]\d{2}|6011|3[47]\d{2})([-\s]?)\d{4}\1\d{4}\1\d{3,4}$/;
        return _this.is(function (value) {
          return lettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isNumberRange", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be valid number range");
        };
        var lettersAndNumbersRegularExpression = /^-?(\d+|\d*\.\d+)--?(\d+|\d*\.\d+)$/;
        return _this.is(function (value) {
          return lettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isShortIsoDate", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be valid ISO date");
        };
        var lettersAndNumbersRegularExpression = /^\\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])$/;
        return _this.is(function (value) {
          return lettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isFileName", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a valid file name");
        };
        var lettersAndNumbersRegularExpression = /^(?:[\0-!#-\)\+-\.0-9;=@-\[\]-\{\}-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+$/;
        return _this.is(function (value) {
          return lettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLettersAndNumbersAndSpaces", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only letters and numbers and spaces");
        };
        var lettersAndNumbersRegularExpression = /^[\pA-Za-z0-9\s]*$/;
        return _this.is(function (value) {
          return lettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isEnglishLettersAndNumbers", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only english letters and numbers");
        };
        var englishLettersAndNumbersRegularExpression = /^[A-Za-z0-9]+$/;
        return _this.is(function (value) {
          return englishLettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isUpperCaseEnglishLettersAndNumbers", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only upper case english letters and numbers");
        };
        var upperCaseEnglishLettersAndNumbersRegularExpression = /^[A-Z0-9]+$/;
        return _this.is(function (value) {
          return upperCaseEnglishLettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLowerCaseEnglishLettersAndNumbers", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only lower case english letters and numbers");
        };
        var lowerCaseEnglishLettersAndNumbersRegularExpression = /^[a-z0-9]+$/;
        return _this.is(function (value) {
          return lowerCaseEnglishLettersAndNumbersRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isKebabCase", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be kebab case");
        };
        var kebabCaseRegularExpression = /^([a-z]+[-][a-z]+)+$/;
        return _this.is(function (value) {
          return kebabCaseRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isCamelCase", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be camel case");
        };
        var camelCaseRegularExpression = /^[a-z]([a-z0-9]+[A-Z][a-z0-9]+)+$/;
        return _this.is(function (value) {
          return camelCaseRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isPascalCase", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be pascal case");
        };
        var pascalCaseRegularExpression = /^[A-Z]([a-z0-9]+[A-Z][a-z0-9]+)+$/;
        return _this.is(function (value) {
          return pascalCaseRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isSnakeCase", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be snake case");
        };
        var snakeCaseRegularExpression = /^[a-z]([a-z0-9]+[_][a-z0-9]+)+$/;
        return _this.is(function (value) {
          return snakeCaseRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isUpperCaseSnakeCase", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be upper case snake case");
        };
        var upperCaseSnakeCaseRegularExpression = /^[A-Z]([A-Z0-9]+[_][A-Z0-9]+)+$/;
        return _this.is(function (value) {
          return upperCaseSnakeCaseRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isBase32", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only base32 characters");
        };
        var base32RegularExpression = /^[A-Z2-7]+=*$/;
        return _this.is(function (value) {
          return base32RegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isBase64", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " contain only base64 characters");
        };
        var base64RegularExpression = /^(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/i;
        return _this.is(function (value) {
          return base64RegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isRgbColor", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a RGB color");
        };
        var rgbColorRegularExpression = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),\s*){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
        var rgbColorPercentRegularExpression = /^rgb\((([0-9]%|[1-9][0-9]%|100%),\s*){2}([0-9]%|[1-9][0-9]%|100%)\)$/;
        return _this.is(function (value) {
          return rgbColorRegularExpression.test(value) || rgbColorPercentRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isRgbaColor", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a RGBA color");
        };
        var rgbaColorRegularExpression = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),\s*){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
        var rgbaColorPercentRegularExpression = /^rgba\((([0-9]%|[1-9][0-9]%|100%),\s*){3}(0?\.\d+|1(\.0)?|0(\.0)?)\)$/;
        return _this.is(function (value) {
          return rgbaColorRegularExpression.test(value) || rgbaColorPercentRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isHslColor", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a HSL color");
        };
        // prettier-ignore
        // eslint-disable-next-line max-len
        var hslColorCommaExpression = /^(hsl)a?\(\s*((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn|\s*)(\s*,\s*(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s*(,\s*((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s*)?\)$/i;
        // prettier-ignore
        // eslint-disable-next-line max-len
        var hslColorSpaceRegularExpression = /^(hsl)a?\(\s*((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn|\s)(\s*(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s*(\/\s*((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s*)?\)$/i;
        return _this.is(function (value) {
          return hslColorCommaExpression.test(value) || hslColorSpaceRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isHexColor", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a HEX color");
        };
        var hexColorRegularExpression = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
        return _this.is(function (value) {
          return hexColorRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isCronjobPattern", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be a Cronjob pattern");
        };
        // prettier-ignore
        // eslint-disable-next-line max-len
        var cronjobPatternRegularExpression = /^(\*|([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])|\*\/([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])) (\*|([0-9]|1[0-9]|2[0-3])|\*\/([0-9]|1[0-9]|2[0-3])) (\*|([1-9]|1[0-9]|2[0-9]|3[0-1])|\*\/([1-9]|1[0-9]|2[0-9]|3[0-1])) (\*|([1-9]|1[0-2])|\*\/([1-9]|1[0-2])) (\*|([0-6])|\*\/([0-6]))$/;
        return _this.is(function (value) {
          return cronjobPatternRegularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isMatching", function (regularExpression) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " match with '").concat(regularExpression, "' expression");
        };
        return _this.is(function (value) {
          return regularExpression.test(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isEmpty", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? ' not' : '', " be empty");
        };
        return _this.is(function (value) {
          return _.isEmpty(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isNotEmpty", function () {
        var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
          return "string should".concat(isNegatedValidation ? '' : ' not', " be empty");
        };
        return _this.is(function (value) {
          return !_.isEmpty(value);
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "string length should".concat(isNegatedValidation ? ' not' : '', " be exactly '").concat(length, "'");
        };
        return _this.is(function (value) {
          return _.size(value) === length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isMaxLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "string length should".concat(isNegatedValidation ? ' not' : '', " be maximum '").concat(length, "'");
        };
        return _this.is(function (value) {
          return _.size(value) <= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isMinLengthOf", function (length) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "string length should".concat(isNegatedValidation ? ' not' : '', " be minimum '").concat(length, "'");
        };
        return _this.is(function (value) {
          return _.size(value) >= length;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "isLengthInRangeOf", function (minLength, maxLength) {
        var errorMessageGetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (isNegatedValidation) {
          return "string length should".concat(isNegatedValidation ? ' not' : '', " be between '").concat(minLength, "' and '").concat(maxLength, "'");
        };
        return _this.is(function (value) {
          return _.size(value) >= minLength && _.size(value) <= maxLength;
        }, errorMessageGetter);
      }), _defineProperty(_assertThisInitialized(_this), "includes", function (substring) {
        var errorMessageGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (isNegatedValidation) {
          return "'".concat(substring, "' should").concat(isNegatedValidation ? ' not' : '', " be included in the string");
        };
        return _this.is(function (value) {
          return _.includes(value, substring);
        }, errorMessageGetter);
      })),
      setChildInstance = _ref.setChildInstance;
    setChildInstance(_this);
    _this.isString(_errorMessageGetter);
    return _this;
  }

  /**
   * @param {function(boolean): string} errorMessageGetter
   * @example string().isEmail().validate('example@gmail.com')
   */
  _inherits(StringValidation, _GenericValidation);
  return _createClass(StringValidation);
}(GenericValidation);

var generic = function generic() {
  return new GenericValidation();
};

/** @param {function(boolean): string} errorMessageGetter */
var array = function array() {
  var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
    return "value should".concat(isNegatedValidation ? ' not' : '', " be an array");
  };
  return new ArrayValidation(errorMessageGetter);
};

/** @param {function(boolean): string} errorMessageGetter */
var boolean = function boolean() {
  var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
    return "value should".concat(isNegatedValidation ? ' not' : '', " be a boolean");
  };
  return new BooleanValidation(errorMessageGetter);
};

/** @param {function(boolean): string} errorMessageGetter */
var functions = function functions() {
  var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
    return "value should".concat(isNegatedValidation ? ' not' : '', " be a function");
  };
  return new FunctionValidation(errorMessageGetter);
};

/** @param {function(boolean): string} errorMessageGetter */
var number = function number() {
  var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
    return "value should".concat(isNegatedValidation ? ' not' : '', " be a number");
  };
  return new NumberValidation(errorMessageGetter);
};

/** @param {function(boolean): string} errorMessageGetter */
var object = function object() {
  var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
    return "value should".concat(isNegatedValidation ? ' not' : '', " be an object");
  };
  return new ObjectValidation(errorMessageGetter);
};

/** @param {function(boolean): string} errorMessageGetter */
var string = function string() {
  var errorMessageGetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (isNegatedValidation) {
    return "value should".concat(isNegatedValidation ? ' not' : '', " be a string");
  };
  return new StringValidation(errorMessageGetter);
};
var validations = {
  HttpResponseParser: HttpResponseParser,
  generic: generic,
  array: array,
  boolean: boolean,
  functions: functions,
  number: number,
  object: object,
  string: string
};

export { HttpResponseParser, array, boolean, validations as default, functions, generic, number, object, string };
